module.exports = __webpack_public_path__ + "img/payment-failed.66953387.png";